// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout[data-v-b93a3090]{display:flex;flex-direction:column}.layout .layout-wrapper[data-v-b93a3090]{display:flex;flex:1 1 auto;flex-direction:column;min-height:100vh;width:100%}.layout .layout-inner-container[data-v-b93a3090]{flex:1 1 auto;margin-top:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
